export const shouldUseHashStrategy = true;
